import commonAPI from "../commonAPI";

const AuthAPI = {
  login: async (email, password) => {
    const data = await commonAPI.post("/auth/login", { email, password });
    const { token, user } = data;
    return { token, user };
  },

  // Register (admin only)
  register: async (data) => {
    commonAPI.post("/auth/register", data);
  },

  // Get all users (admin only)
  getUsers: async () => {
    commonAPI.get("/auth/users");
  },

  // Logout
  logout: () => {
    localStorage.removeItem("token");
  },
};

export default AuthAPI;
